import { useRichTextRenderer } from './useRichTextRenderer';
import { computed, toValue } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

export function useHeroComponentContent(
    blok: MaybeRefOrGetter<HeroComponentStoryblok | ProductOfTheMonthHeroStoryblok>
) {
    const heroBlok = computed(() => toValue(blok));
    const { renderToString } = useRichTextRenderer();
    const headlineContent = computed(() => (heroBlok.value.headline ? renderToString(heroBlok.value.headline) : ''));
    const asset = computed<StoryblokAsset | undefined>(() => heroBlok.value.asset);
    const mediaSrc = computed(() => asset.value?.filename ?? '');
    const mediaAlt = computed(() => asset.value?.alt ?? asset.value?.title ?? 'Hero Media');
    const mediaContentType = computed(() => asset.value?.content_type ?? '');

    return {
        headlineContent,
        asset,
        mediaSrc,
        mediaAlt,
        mediaContentType
    };
}
